import React from "react";

const EnrollmentSuccessMessage = ({ onReturnHome }) => {
  return (
    <div
      className="card shadow border-0 w-100"
      style={{ maxWidth: "600px", borderRadius: "20px", overflow: "hidden" }}
    >
      <div className="card-body p-5 text-center">
        <div
          className="mx-auto d-flex align-items-center justify-content-center rounded-circle mb-4"
          style={{
            width: "80px",
            height: "80px",
            background: "linear-gradient(135deg, #d6258f 0%, #9d3bf0 100%)",
            color: "white",
            fontSize: "40px"
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
          </svg>
        </div>
        <h2 className="fw-bold mb-3" style={{ color: "#d6258f" }}>
          Thank You!
        </h2>
        <p className="text-muted mb-4" style={{ fontSize: "1.1rem" }}>
          We'll review your submission and notify you once your listing is live.
        </p>

        <p className="small text-muted mb-4">
          Practices using Dental.com Office may receive priority placement, but
          use of Dental.com Office is not a requirement for listing.
        </p>
        <button
          onClick={onReturnHome}
          className="btn text-white rounded-pill px-5 py-2 fw-bold shadow-sm mb-4"
          style={{
            background: "linear-gradient(90deg, #9d3bf0 0%, #d6258f 100%)",
            border: "none"
          }}
        >
          Return to Home
        </button>
        <div>
          <a
            href="https://dental.com/"
            className="small text-decoration-underline"
            style={{ color: "#9d3bf0" }}
          >
            Click here to learn more about Dental.com Office
          </a>
        </div>
      </div>
    </div>
  );
};

export default EnrollmentSuccessMessage;
